import Joi from 'joi';
const storiesBlockSchema = Joi.object({
  type: Joi.string().valid('storiesBlock').required(),
  code: Joi.string().allow('', null).optional(),
  columns: Joi.number().valid(2, 3, 4, 6).allow(null).optional(),
  mobileColumns: Joi.number().valid(1, 2).allow(null).optional(),
  showCardArrows: Joi.boolean().allow(null).optional(),
  cardVariant: Joi.string().valid('story').allow(null).optional(),
  cards: Joi.array().items(Joi.object({
    id: Joi.string().required(),
    title: Joi.string().allow('').required(),
    subtitle: Joi.string().allow('', null).optional(),
    text: Joi.string().allow('', null).optional(),
    target: Joi.string().allow('', null).optional(),
    href: Joi.string().allow('', null).required(),
    image: Joi.string().allow('', null).optional(),
    products: Joi.array().items(Joi.object({
      id: Joi.number().required(),
      name: Joi.string().required()
    }).unknown(true)).allow(null).empty(true)
  }).unknown(true)).required()
}).unknown(true);
export default storiesBlockSchema;